module.exports = __webpack_public_path__ + "img/teach_02.cd28ecf3.jpg";